import Home from "./pages/Home";
import User from "./pages/User";
import AddFreeOrder from "./pages/FreeOrder/AddFreeOrder";
import ViewFreeOrders from "./pages/FreeOrder/ViewFreeOrders";
import { Route, Routes, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Inventory from "./pages/Inventory";
import InventoryUk from "./pages/InventoryUk";
import AbReport from "./pages/AbReport";
import { isRestrictedUser } from "./utils/tokenUtils";

// Protected route wrapper for restricted users
const ProtectedRoute = ({
  element,
  allowedForRestrictedUser = false,
  restrictedOnly = false,
}) => {
  const restricted = isRestrictedUser("vkommi@gmail.com");

  if (restricted && !allowedForRestrictedUser) {
    // Redirect to inventory-uk if restricted user tries to access other routes
    return <Navigate to="/inventory-uk" replace />;
  }

  return element;
};

const BrowseRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ProtectedRoute element={<Home />} />} />
      <Route
        path="/user/:userId"
        element={<ProtectedRoute element={<User />} />}
      />
      <Route
        path="/add-free-order"
        element={<ProtectedRoute element={<AddFreeOrder />} />}
      />
      <Route
        path="/free-orders"
        element={<ProtectedRoute element={<ViewFreeOrders />} />}
      />
      <Route
        path="/ab-report"
        element={<ProtectedRoute element={<AbReport />} />}
      />
      <Route path="/login" element={<Login />} />
      <Route
        path="/inventory"
        element={<ProtectedRoute element={<Inventory />} />}
      />
      <Route
        path="/inventory-uk"
        element={
          <ProtectedRoute
            element={<InventoryUk />}
            allowedForRestrictedUser
            restrictedOnly
          />
        }
      />
    </Routes>
  );
};

export default BrowseRoutes;
